import React from 'react';
import { useForm } from 'react-final-form';

import { useIntl } from '../../util/reactIntl';
import SchoolSearchField from '../../components/SchoolSearchField/SchoolSearchField';

/**
 * Renders a postcode-based school search in place of the display name text field
 * when the selected user type is 'school'. The selected school name is saved as
 * the user's displayName, and the URN is saved as schoolId.
 */
const UserFieldSchoolSelect = () => {
  const form = useForm();
  const intl = useIntl();

  const handleSelect = school => {
    form.change('displayName', school.name);
    form.change('schoolId', Number(school.urn));
  };

  return (
    <div>
      <label>{intl.formatMessage({ id: 'SignupForm.schoolNameLabel' })}</label>
      <SchoolSearchField onSelect={handleSelect} />
    </div>
  );
};

export default UserFieldSchoolSelect;
